import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const DashboardPage = lazy(() =>
	import("./pages/dashboard.page").then((m) => ({ default: m.DashboardPage })),
);
const LogActivityPage = lazy(() =>
	import("./pages/log-activity.page").then((m) => ({ default: m.LogActivityPage })),
);
const LogStrengthPage = lazy(() =>
	import("./pages/log-strength.page").then((m) => ({ default: m.LogStrengthPage })),
);
const LogMobilityPage = lazy(() =>
	import("./pages/log-mobility.page").then((m) => ({ default: m.LogMobilityPage })),
);
const ActivityLogPage = lazy(() =>
	import("./pages/activity-log.page").then((m) => ({ default: m.ActivityLogPage })),
);
const GoalsPage = lazy(() => import("./pages/goals.page").then((m) => ({ default: m.GoalsPage })));

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({ getParentRoute: () => parentRoute, path: "/fitstreak", component: DashboardPage }),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/fitstreak/log/activity",
		component: LogActivityPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/fitstreak/log/strength",
		component: LogStrengthPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/fitstreak/log/mobility",
		component: LogMobilityPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/fitstreak/activities",
		component: ActivityLogPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/fitstreak/goals",
		component: GoalsPage,
	}),
];
